import * as React from 'react';
import { ComponentProps } from 'ui';
import styles from './section-panel.scss';
import { ValidationSummary, ValidationProps } from '../common';
import { DisplayTextWithLinks } from 'ui/common/display-text-with-links';

export interface SectionPanelProps extends ComponentProps {
  children?: React.ReactNode;
  validation: ValidationProps;
  isMain?: boolean;
}

export const SectionPanel: React.SFC<SectionPanelProps> = (props: SectionPanelProps) => {

  const {
    componentId,
    children = '',
    label = {},
    validation,
    info,
    isMain
  } = props;

  const infoText = <DisplayTextWithLinks componentId={`${componentId}_infotext`} text={info && info.text} linkify={info && info.linkify} />;

  return (
    <section id={componentId} className={`${styles.section}`}>
      {label.visible &&
        <h2 className={`${styles.sectionHeading} ${isMain && styles.sectionHeadingParent} main-grid`}>{label.text}
          {info.visible && <div className={`${styles.sectionInfoText}`}>{infoText}</div>}
        </h2>}
      <div className={styles.sectionValidation}>
        <ValidationSummary validationError={validation} />
      </div>
      <div className={`main-grid ${styles.sectionItems}`}>
        {children}
      </div>
    </section>
  );
};
